import { memo, useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchDocuments, resetTabState, updateRequestBody } from "../../../redux/EngageTranslation/EngageTranslationAction";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import TableComponent from "../../TableComponent/TableComponent";
import EngageTranslationQCTableColumns from "../TableComponent/EnageTranslateQCTableColumns";

function QualityControlContent(props: any) {
  const dispatch = useAppDispatch();
  const qualityControlTabState = useSelector((state: RootState) => state.engageTranslationState.qualityControlState);
  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = { ...qualityControlTabState.currentRequestBody, sortColumn: sorter.field, isAsc: isAscend(sorter.order) };
    dispatch(resetTabState("quality-control"));
    dispatch(updateRequestBody({ requestBody: newSortingRequestBody, view: "quality-control" }));
    dispatch(fetchDocuments({ view: "quality-control" }));
  };

  //   const newSortingRequestBody = {
  //     ...qualityControlTabState.currentRequestBody,
  //     sortColumn: sorter.field,
  //     isAsc: isAscend(sorter.order),
  //   };
  //   dispatch(updateRequestBody(newSortingRequestBody));
  //   dispatch(fetchDocuments({ view: "quality-control" }));
  // };

  return (
    <div className="d-flex flex-column full-flex h-100 mt-2 px-2">
      <div className="d-flex flex-column full-flex gap-3 overflow-hidden">
        <TableComponent
          dataSource={qualityControlTabState.data}
          columns={EngageTranslationQCTableColumns}
          tableKey={"quality-control"}
          handleTableSorting={handleTableSorting}
          pagination={qualityControlTabState.pagination}
          loading={qualityControlTabState.loading}
        />
      </div>
    </div>
  );
}

export default memo(QualityControlContent);
